import { render, staticRenderFns } from "./MonitorPendenciasAgregada.vue?vue&type=template&id=078797be&"
import script from "./MonitorPendenciasAgregada.vue?vue&type=script&lang=js&"
export * from "./MonitorPendenciasAgregada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports